module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-solid-straight-ITFA7HIK.woff?ab88e50e21486ce8c779768b54372bd1";